function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { safeGlobal } from '../util/global';
export class ConnectorUserProvider {
  constructor(identityStore) {
    _defineProperty(this, "identityStore", void 0);

    this.identityStore = identityStore;
  }

  async identityReady(ms) {
    const identity = this.identityStore.getIdentity();

    if (!identity.userId && !identity.deviceId) {
      return Promise.race([new Promise(resolve => {
        const listener = () => {
          resolve();
          this.identityStore.removeIdentityListener(listener);
        };

        this.identityStore.addIdentityListener(listener);
      }), new Promise((_, reject) => {
        safeGlobal.setTimeout(reject, ms, 'Timed out waiting for Amplitude Analytics SDK to initialize. ' + 'You must ensure that the analytics SDK is initialized prior to calling fetch().');
      })]);
    }
  }

  async getUser() {
    const identity = this.identityStore.getIdentity();
    let userProperties;

    try {
      userProperties = identity.userProperties;
    } catch {
      console.warn('[Experiment] failed to cast user properties');
    }

    return {
      user_id: identity.userId,
      device_id: identity.deviceId,
      user_properties: userProperties
    };
  }

}
export class ConnectorExposureTrackingProvider {
  constructor(eventBridge) {
    _defineProperty(this, "eventBridge", void 0);

    this.eventBridge = eventBridge;
  }

  track(exposure) {
    this.eventBridge.logEvent({
      eventType: '$exposure',
      eventProperties: exposure
    });
  }

}
//# sourceMappingURL=connector.js.map